if (!customElements.get('welcome-popup')) {
  class WelcomePopup extends HTMLElement {
    connectedCallback() {
      const endDate = new Date(this.dataset.countdownEnd);

      if (Number.isNaN(endDate.getTime()) || endDate.getTime() <= Date.now()) {
        this.remove();
        return;
      }

      if (sessionStorage.getItem('rea-welcome-popup-shown') === 'true') {
        this.remove();
        return;
      }
      sessionStorage.setItem('rea-welcome-popup-shown', 'true');

      this.dialog = this.querySelector('.welcome-popup__dialog');

      this.querySelector('[data-welcome-popup-close]').addEventListener('click', this.close.bind(this));
      this.querySelector('[data-welcome-popup-overlay]').addEventListener('click', this.close.bind(this));
      this.addEventListener('keydown', this.onKeyDown.bind(this));
      this.addEventListener('countdown:expired', this.close.bind(this));

      this.open();
    }

    open() {
      this.removeAttribute('hidden');
      document.body.classList.add('overflow-hidden');
      this.openedBy = document.activeElement;
      trapFocus(this, this.dialog);
    }

    close() {
      if (this.hasAttribute('hidden')) return;
      this.setAttribute('hidden', '');
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.openedBy);
    }

    onKeyDown(event) {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') this.close();
    }
  }

  customElements.define('welcome-popup', WelcomePopup);
}
